import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckNodes } from '@api/consistencyCheck';

import { extractQueryParams } from '@utils/common';
import { fieldsOptionsFormatted } from '@utils/formatter';

import { ICMMavenirVendor } from '@interfaces/cmModule/cmModule';
import { IModalSelectOption } from '@components/common/ModalSelect/ModalSelect.types';

import { TVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_NODE_TYPES } from '@constants/queryKeys';

type TUseConsistencyCheckNodes = {
	vendor?: TVendorsValues;
} & ICMMavenirVendor;

const useQueryConsistencyCheckNodes = (params: TUseConsistencyCheckNodes) => {
	const {
		vendor,
		isMavenirVendor,
	} = params;

	const {
		data: nodesOptions,
		isLoading: isLoadingNodeOptions,
		isFetching: isFetchingNodeOptions,
	} = useQuery<string[], IModalSelectOption[]>({
		queryKey: [
			CONSISTENCY_NODE_TYPES,
			vendor,
			isMavenirVendor,
		],
		queryFn: extractQueryParams(getConsistencyCheckNodes),
		select: (options: Array<string>) => fieldsOptionsFormatted(options.sort((a, b) => Number(a) - Number(b))),
		enabled: [vendor, isMavenirVendor],
		...refetchOptions,
	});

	return {
		nodeOptions: nodesOptions || [],
		isLoadingNodeOptions: (isLoadingNodeOptions && !!nodesOptions)
			|| isFetchingNodeOptions,
	};
};

export default useQueryConsistencyCheckNodes;
